import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { AuthService } from "../../../auth/auth.service";
import { PopoverComponent } from "../../../shared/panel/popover/popover.component";
import { ArrayHelper } from "../../../utilities/contracts/array-helper";
import { StringHelper } from "../../../utilities/contracts/string-helper";
import { ChartService } from "../../api/chart-lake/chart.service";
import { AlertNotification } from "../../notification/alert-notification.model";
import { NotificationType } from "../../notification/notification-type.enum";
import { NotificationService } from "../../notification/notification.service";

@Component({
  selector: "platform-notifications",
  templateUrl: "./notifications.component.html",
  styleUrls: ["./notifications.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationsComponent implements OnInit, OnDestroy {
  private intervalUpdateCount;
  notifications: AlertNotification[];
  read: boolean;
  unreadNotificationCount = 0;

  @ViewChild("overlay", { static: true }) private overlay: PopoverComponent;


  constructor(
    private readonly service: NotificationService,
    private authService: AuthService,
    private chartService: ChartService,
    private changeDetector: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.service.eventCallback$.subscribe(data => {
      this.unreadNotificationCount = data;
      this.changeDetector.markForCheck();
  });
    this.getUnreadNotificationCount();
    if ((this.authService.user.isEmployeeRole && this.authService.user.isAdminRole) || !this.authService.user.isEmployeeRole) {
      this.intervalUpdateCount = setInterval(() => {
        this.getUnreadNotificationCount();
      },                                     120000);
    }
  }

  ngOnDestroy() {
    clearInterval(this.intervalUpdateCount);
  }


  get hasUnreadNotifications(): boolean {
    return this.unreadNotificationCount > 0;
  }

  get unreadAndActiveClass(): string {
    const unread = this.hasUnreadNotifications ? "notifications__unread" : "";
    const active = this.overlay.visible ? "notifications__active" : "";
    return `${unread} ${active}`.trim();
  }

  get countText(): string {
    return this.hasUnreadNotifications ? this.unreadNotificationCount.toString() : "";
  }

  show(event: MouseEvent) {
    if (!this.overlay.visible) {
      this.getNotificationsAndShow(event);
      this.markAllAsRead();
    }
  }


  private getUnreadNotificationCount() {
    this.service
      .getNotificationCount()
      .subscribe(items => {
        this.unreadNotificationCount = items;
        this.changeDetector.markForCheck();
      });
  }

  private getNotificationsAndShow(event: MouseEvent): void {
    this.service
      .getNotification()
      .subscribe(items => {
        this.notifications = items;
        this.overlay.show(event);
        this.changeDetector.markForCheck();
      });
  }

  private markAllAsRead(): void {
    this.service.ReadNotification().subscribe();
    this.read = false;
    this.unreadNotificationCount = 0;
    this.changeDetector.markForCheck();
  }


  trackByIndex(index, item) {
    return index;
  }

  isMentionAlert(item: AlertNotification): boolean {
    return item.alertTypeId === NotificationType.AT_MENTION && !!item.supplemental && ArrayHelper.isAvailable(item.supplemental.qualifiers);
  }

  onDownloadChartClick(event: Event, item: AlertNotification, overlay: PopoverComponent): void {
    event.preventDefault();
    const jobId = item.supplemental?.qualifiers.find(q => q.name === "jobId")?.id;
    if (StringHelper.isAvailable(jobId) && item.alertTypeId === 5) {
      this.chartService.getPresignedDownloadUrl(jobId).subscribe((url: string) => {
        const link = document.createElement("a");
        link.href = url;
        link.download = "";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    }
    overlay.hide();
  }

}
